<ng-container *ngIf="!studyIdValue">
    <ca-med-tag-studyid-input-field
        class="w-100"
        (createStudyId)="onCreateStudyId($event)"
        [studyIdValue]="studyIdValue"
        [tags]="studyId"
        [isFilesPage]="isFilesPage"
        [name]="'newStudyID'"
        [placeholder]="placeholder"
        [titleKey]="titleKey"
    ></ca-med-tag-studyid-input-field>
</ng-container>

<ng-container *ngIf="studyIdValue">
    <div [caTruncate]="200" data-uit="research-study-id" class="px-2 research-studyId w-100">
        <span class="text-truncate" placement="left" ngbTooltip="{{ studyIdValue }}">{{ studyIdValue }}</span>
    </div>
</ng-container>
